import {Errors} from 'io-ts';

export const createErrorTable = (errors: Errors) => {
    return Object.fromEntries(
        errors.map(err => {
            const property = err.context.map(({key}) => key).join('.');
            let expected = err.context.at(-1)!.type.name;
            if (expected.length > 60) {
                expected = `${expected.slice(0, 60)}...`;
            }
            const received = err.value;
            return [property, {received, expected}];
        })
    );
};

export const getErrorPaths = (result: Errors) => {
    return result
        .map(
            error =>
                `\nWHERE: ${error.context.map(({key}) => key).join('.')}, INVALID VALUE: ${JSON.stringify(error.value, null, 2)}`
        )
        .join('');
};
